/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { get } from 'lodash';
import { Mapper, PresenterType } from '../../../types';
import { flatByAttribute, personDropdownExtraInfo } from '@/pages/sor/new_object/utils';

const mapper: Mapper = {
  fraudRelated: {
    presenter: PresenterType.CheckboxFormPresenter,
  },
  keyControl: {
    presenter: PresenterType.CheckboxFormPresenter,
  },
  means: {
    presenter: PresenterType.DropdownFormPresenter,
    extraInfo: {
      submissionDataParser: flatByAttribute('value'),
      editValueParser: data => {
        const val = get(data, 'value', null);
        return {
          value: val,
          label: val,
        };
      },
    },
  },
  verifyFrequency: {
    presenter: PresenterType.DropdownFormPresenter,
    extraInfo: {
      submissionDataParser: flatByAttribute('value'),
      editValueParser: data => {
        const val = get(data, 'value', null);
        return {
          value: val,
          label: val,
        };
      },
    },
  },
  principalAssessor: {
    presenter: PresenterType.DropdownFormPresenter,
    extraInfo: {
      ...personDropdownExtraInfo,
    },
  },
  secondaryAssessor: {
    presenter: PresenterType.DropdownFormPresenter,
    extraInfo: {
      ...personDropdownExtraInfo,
    },
  },
};

export default {
  mapper,
};
